import Highcharts from 'highcharts';
import {numberRange} from './utilities';

export const figure29 = { 
    chart: {
        zoomType: 'xy',
        animation: false,
        backgroundColor:'rgba(255, 255, 255, 0.0)',
        marginTop: 50,
        style: {
            fontFamily: 'Montserrat'
        }
    },
    credits: {
        enabled: false
    },
    title: {
        text: null
    },
    subtitle: {
        text: null
    },

    exporting: {
        enabled: false
    },

    xAxis: [{
        categories: numberRange(2015, 2018),
        tickInterval: 1,
        crosshair: {
            width: 1,
            color: '#4472c4'
        },
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
            y: 32,
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
    }],

    yAxis: [
        {
        labels: {
            format: '{value}',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        offset: 10,
        gridLineWidth: 2,
        max: 19.5,
        min: 16,
        tickInterval: 0.5,
        title: {
            text: null,
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    legend: {
        enabled: false,
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    lineWidth: 2
                }
            },
            marker: {
                symbol: 'circle',
                states: {
                    hover: {
                        enabled: true,
                        radius: 5
                    }
                }
            }
        }
    },
    series: [ {
        name: '<span>Figura 29: Eficiencia en el uso del agua a nivel mundial, 2015-18 (USD por m<sup>3</sup>)</span>',
        id: "prev",
        type: 'line',
        color: '#5b9bd5',
        zoneAxis: 'x',
        dataLabels: {
            enabled: false,
            style: {
                fontWeight: 'normal',
                textOutline: false,
                color: '#999999',
                fontSize: '12px'
            }

        },

        data: [
            { y: 17.28, dataLabels: {enabled:true}},
            { y: 17.69, dataLabels: {enabled:true}},
            { y: 18.23, dataLabels: {enabled:true}},
            { y: 19.01, dataLabels: {enabled:true}},
        ],
    }],


};
